<template>
  <div>
    <BaseLoader v-if="loading.repartitionPrixContratMoyens || loading.filtres" />
    <BaseMessageServerError v-if="erreur.repartitionPrixContratMoyens" />
    <div
      v-if="!loading.repartitionPrixContratMoyens && !loading.filtres && valeurPerso != null && repartitionPrix.nbAdherentsGroupe > 5 && !erreur.repartitionPrixContratMoyens"
    >
      <!-- graphe prix moyens -->
      <div class="d-flex justify-center">
        <ComparaisonQuartiles
          :data="chartData"
          class="d-flex justify-center"
          :size="$vuetify.breakpoint.mobile ? '100%' : '75%'"
        />
      </div>
      <div
        class="d-flex justify-center secondary--text titre-h4"
      >
        Mon prix de contrat moyen
      </div>
      <div
        class="d-flex justify-center secondary--text chiffre"
      >
        {{ valeurPerso | roundNumber(2) }}
        <span
          :class="$vuetify.breakpoint.mobile ? 'texte' : 'chiffre'"
          class="ml-2 align-self-center secondary--text"
        >€/t</span>
      </div>
      <div
        class=" mx-5 mt-3 d-flex justify-center texte texte-gris-fonce"
      >
        Comparaison avec {{ repartitionPrix.nbAdherentsGroupe }} exploitations de votre région
      </div>
    </div>
    <div
      v-if="(valeurPerso == null || repartitionPrix.nbAdherentsGroupe <= 5) && !loading.repartitionPrixContratMoyens && !loading.filtres && !erreur.repartitionPrixContratMoyens"
    >
      <div
        :class="$vuetify.breakpoint.mobile ? 'mt-6' :'mt-16' "
        class="d-flex
        align-center
        flex-column"
      >
        <img
          alt="no-commercialisation"
          src="@/assets/no-comparaison.svg"
        >
        <div
          :class="$vuetify.breakpoint.mobile ? 'mb-6' :'mx-16' "
          class="intro texte-gris-fonce text-align-center mt-2"
        >
          <span>Gardez un œil sur vos chiffres et comparez-les avec d’autres adhérents</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import numberFilter from '@/filters/number.filter'
import BaseLoader from '@/components/common/base-loader.vue'
import BaseMessageServerError from '@/components/common/base-message-server-error.vue'
import ComparaisonQuartiles from '@/components/chart/v2/comparaison-quartiles.vue'

export default {
  name: 'RepartitionPrixContratMoyen',
  components: { BaseLoader,BaseMessageServerError, ComparaisonQuartiles },
  data () {
    return {
      loading: {
        filtres: false,
        repartitionPrixContratMoyens: false
      },
      erreur: {
        filtres: false,
        repartitionPrixContratMoyens: false
      },
    }
  },

  computed: {
    ...mapGetters({
      repartitionPrix: 'contrat/repartitionPrixContratMoyens',
      filtresAdherent: 'filtresComparaison/filtresAdherent',
      adherent: 'adherent/adherent',
      anneeRecolteActive: 'application/anneeRecolteActive',
      codeGraineActive: 'application/codeGraineActive'
    }),
    valeurPerso () {
      return this.repartitionPrix.positionPersoDuNumtiers && this.repartitionPrix.positionPersoDuNumtiers.valeur ? this.repartitionPrix.positionPersoDuNumtiers.valeur : null
    },

    chartData () {
      return {
        measure: {
          value: this.repartitionPrix.positionPersoDuNumtiers ? numberFilter.formatNumber(this.repartitionPrix.positionPersoDuNumtiers.valeur, 0) : null,
          legend: this.repartitionPrix.positionPersoDuNumtiers ? numberFilter.formatNumber(this.repartitionPrix.positionPersoDuNumtiers.valeur,2) + ' €/t' : null
        },
        min: {
          value: this.repartitionPrix.min ? numberFilter.formatNumber(this.repartitionPrix.min.valeur, 0) : null,
          label: null
        },
        quartile1: {
          value: this.repartitionPrix.quartile1 ? numberFilter.formatNumber(this.repartitionPrix.quartile1.valeur, 0) : null,
          label: 'Quart inf.'
        },
        mediane: {
          value: this.repartitionPrix.quartile2 ? numberFilter.formatNumber(this.repartitionPrix.quartile2.valeur, 0) : null,
          label: 'Médiane'
        },
        quartile2: {
          value: this.repartitionPrix.quartile3 ? numberFilter.formatNumber(this.repartitionPrix.quartile3.valeur, 0) : null,
          label: 'Quart sup.'
        },
        max: {
          value: this.repartitionPrix.max ? numberFilter.formatNumber(this.repartitionPrix.max.valeur, 0) : null,
          label: null,
        },
        quarters: [
          { color: '#ec6608', legend: this.repartitionPrix.quartile1 ? (this.repartitionPrix.quartile1.nombreValeursInferieures - this.repartitionPrix.min.nombreValeursInferieures) + ' producteur(s) ont un prix inférieur à '+ numberFilter.formatNumber(this.repartitionPrix.quartile1.valeur,0) + ' €' : null},
          { legend: this.repartitionPrix.quartile2 ? (this.repartitionPrix.quartile2.nombreValeursInferieures - this.repartitionPrix.quartile1.nombreValeursInferieures) + ' producteur(s) ont un prix compris entre ' + numberFilter.formatNumber(this.repartitionPrix.quartile1.valeur,0) + ' € et ' + numberFilter.formatNumber(this.repartitionPrix.quartile2.valeur,0) + ' €' : null},
          { legend: this.repartitionPrix.quartile3 ? (this.repartitionPrix.quartile3.nombreValeursInferieures - this.repartitionPrix.quartile2.nombreValeursInferieures) + ' producteur(s) ont un prix compris entre ' + numberFilter.formatNumber(this.repartitionPrix.quartile2.valeur,0) + ' € et ' + numberFilter.formatNumber(this.repartitionPrix.quartile3.valeur,0) + ' €' : null},
          { color: '#01713C', legend: this.repartitionPrix.max ? (this.repartitionPrix.max.nombreValeursInferieures - this.repartitionPrix.quartile3.nombreValeursInferieures + 1) + ' producteur(s) ont un prix supérieur à ' + numberFilter.formatNumber(this.repartitionPrix.quartile3.valeur, 0) + ' €' : null }
        ],

        unit: '€',
        icon: 'mdi-account'
      }
    }
  },
  watch: {
    anneeRecolteActive: {
      handler () {
        this.initDonnees()
      },
      immediate: true
    },
    codeGraineActive () {
      this.initDonnees()
    }
  },
  methods: {
    ...mapActions({
      getPrixContratMoyenComparaison: 'contrat/getPrixContratMoyenComparaison',
      initFiltres: 'filtresComparaison/initFiltres'
    }),
    initDonnees () {
      this.loading.filtres = true
      this.erreur.filtres = false

      return this.initFiltres(this.adherent.codeRegion)
        .then(() => {
          this.loadRepartitionPrixContratMoyen()
        })
        .catch(() => {
          this.erreur.filtres = true
        })
        .finally(() => {
          this.loading.filtres = false
        })
    },
    loadRepartitionPrixContratMoyen () {
      this.loading.repartitionPrixContratMoyens = true
      this.erreur.repartitionPrixContratMoyens = false

      const params = {
        filtres: this.filtresAdherent
      }
      this.getPrixContratMoyenComparaison(params)
        .catch(() => {
          this.erreur.repartitionPrixContratMoyens = true
        })
        .finally(() => {
          this.loading.repartitionPrixContratMoyens = false
          this.$emit('checkIfData', this.valeurPerso!= null && !this.loading.repartitionPrixContratMoyens && !this.loading.filtres)

        })
    }
  }
}

</script>

<style lang="scss" scoped>
.jauge {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.opacity {
  opacity: 0.2;
  zoom: 75%;
}
</style>
